module.exports = __webpack_public_path__ + "img/button-refresh-arrows.50fdee81.svg";